import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c510c47c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-container" }
const _hoisted_2 = { class: "inner-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "核桃活动"),
  /*#__PURE__*/_createElementVNode("div", { class: "title-desc" }, "众多活动期待你的参与")
], -1))
const _hoisted_4 = { class: "swiper-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperHeader = _resolveComponent("SwiperHeader")!
  const _component_SwiperActivitySlide = _resolveComponent("SwiperActivitySlide")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.homeService.navBarList.length)
          ? (_openBlock(), _createBlock(_component_SwiperHeader, {
              key: 0,
              ref: "swiperHeaderRef",
              list: _ctx.homeService.navBarList,
              onChange: _ctx.onChangeHeader
            }, null, 8, ["list", "onChange"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Swiper, {
          "slides-per-view": 1,
          "space-between": 0,
          onSwiper: _ctx.onInitSwiper,
          onSlideChange: _ctx.onSlideChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.homeService.navBarList, (activity, index) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_SwiperActivitySlide, { data: activity }, null, 8, ["data"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["onSwiper", "onSlideChange"])
      ])
    ])
  ]))
}